import React, { Component } from 'react';
import { Modal } from 'antd';
import styles from './PromoNotifModal.module.css';
import Spinner from 'components/UI/Spinner/Spinner';

class PromoNotifModal extends Component {
  state = { visible: false };

  componentDidMount() {
    console.log('mounted');
  }

  render() {
    return (
      <Modal
        title="Notifying Contractors"
        wrapClassName={styles.Modal}
        visible={this.props.visible || this.state.visible}
        width={350}
        footer={null}
      >
        <Spinner type="Default" size="large" />
      </Modal>
    );
  }
}

export default PromoNotifModal;



// WEBPACK FOOTER //
// ./src/components/Promo/PromoNotifModal.js